<template>
  <q-input
    v-model="editTime"
    outlined
    type="time"
    :label="label"
    stack-label
    :disable="disable"
    :rules="rules"
    :dense="dense"
    lazy-rules
  >
    <template
      v-for="(_, name) in $slots"
      #[name]
    >
      <slot
        :name="name"
      />
    </template>
  </q-input>
</template>
<script>
import { Timestamp } from 'firebase/firestore';
import { isObject, parseInt } from 'lodash';
import { useTime } from 'src/composables/time';

/**
 * @deprecated Use `HrTimeField` from `src/design-system`, or `HrTimeRangeField` for a from/to pair.
 * Every prop here has a counterpart there, and the model is the same Timestamp.
 */
export default {
  name: 'TimeInput',

  props: {
    modelValue: {
      type: Object,
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    dense: {
      type: Boolean,
      default: false,
    },
    preserveDate: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: null,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    allowEmpty: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['update:modelValue'],

  setup() {
    const { formatDate, adjustDate, isValid } = useTime();
    return { formatDate, adjustDate, isValid };
  },

  computed: {

    rules() {
      if (this.errorMessage === null) {
        return;
      }
      return [() => (!!this.editTime || this.errorMessage)];
    },

    editTime: {
      get() {
        if (!isObject(this.modelValue)) {
          // Safari require us to set a value, or it will show an annoying placeholder
          return this.allowEmpty ? '' : '00:00';
        }
        return this.formatDate(this.modelValue.toDate(), 'HH:mm');
      },
      set(timeValue) {
        let dateOffset;
        let hours;
        let minutes;

        if (timeValue.length !== 5) {
          if (!this.preserveDate) {
            return this.$emit('update:modelValue', null);
          }
          hours = 0;
          minutes = 0;
        } else {
          [hours, minutes] = timeValue.split(':');
        }

        if (this.preserveDate && this.modelValue instanceof Timestamp) {
          dateOffset = this.modelValue.toDate();
        } else {
          dateOffset = Date.now();
        }

        const dateAndTime = this.adjustDate(dateOffset, { hour: parseInt(hours), minute: parseInt(minutes) });

        if (!this.isValid(dateAndTime)) {
          return this.$emit('update:modelValue', null);
        }

        this.$emit('update:modelValue', Timestamp.fromDate(dateAndTime));
      },
    }, // editTime()
  },

};
</script>
